import { BrandSettings } from "./brand";
export const config = {
    defaultAlertDuration: {
        success: 2000,
        info: 5000,
        warning: 5000,
        danger: 5000
    }
};
type Brands = BrandSettings["brandName"];
interface BrandSpecificAuth0Config {
    "clientId": string;
    "redirect_uri": string;
}
type Auth0Config = {
    [brand in Brands]?: BrandSpecificAuth0Config;
} & {
    domain: string;
    customDomain?: string;
    audience: string;
    allowed_connections: string[];
};
export interface Configuration {
    auth0Enabled: boolean;
    auth0: Auth0Config;
    brandName?: string;
    churnZeroAppKey?: string;
    portalApiUrl?: string;
    brandSettings: BrandSettings;
    debug: boolean;
    entry: string;
    identityServerUrl?: string;
    adminApiUrl?: string;
    serviceProApiUrl: string;
    defaultCompanyGuid: string;
    cdnUrls: string[];
    defaultCdnVersion?: string;
}